export default __webpack_public_path__ + "static/media/vol_off_tooltip.6bd55554.svg";